import { addMetadata } from "./ModuleBase/ModuleMetadata";
import { getImageUrlInBase64 } from "../../data/images";

export function setBackgroundImage(imgId, canvas, context, drawingHistory) {
	if (!imgId) {
		canvas.backgroundImage = 0;
		canvas.renderAll();
		drawingHistory.save();
		context.selectedValue = 0;
		return;
	}

	getImageUrlInBase64(imgId)
		.then(urlInBase64 => {
			fabric.Image.fromURL(urlInBase64, img => {
				const origSize = getCanvasA4Size();
				const hRatio = origSize.w / img.width;
				const vRatio = origSize.h / img.height;
				const ratio = Math.min(hRatio, vRatio);
				img.scale(ratio);
				canvas.setBackgroundImage(img, () => {
					canvas.renderAll();
					drawingHistory.save();
				});
				if (context) context.selectedValue = imgId;
			});
		})
		.catch(a => console.log(a));
}

export function loadFullsizeImage(imgId, canvas, context, drawingHistory) {
	return new Promise((resolve, reject) => {
		let imgSize
		if (!imgId) {
			canvas.backgroundImage = 0;
			canvas.renderAll();
			drawingHistory.save();
			context.selectedValue = 0;
			imgSize = { w: 0, h: 0 }
			resolve(imgSize)
		} else {
			getImageUrlInBase64(imgId)
				.then(urlInBase64 => {
					fabric.Image.fromURL(urlInBase64, img => {
						imgSize = { w: img.width, h: img.height }
						if (!canvas.getWidth()) {
							canvas.setWidth(imgSize.w);
							canvas.setHeight(imgSize.h);
							canvas.renderAll();
						}
						canvas.setBackgroundImage(img, () => {
							canvas.renderAll();
							drawingHistory.save();
						});
						if (context) context.selectedValue = imgId;

						resolve(imgSize);
					})
				})
				.catch(err => {
					console.error(err);
					reject(err);
				});
		}
	})
}

export function resetModulesMetadata(canvas) {
	canvas.forEachObject(o => {
		if (o.moduleName && o.moduleState) {
			addMetadata(o, o.moduleState);
		}
	});
}

export function clearSelection(canvas) {
	canvas.discardActiveObject();
	canvas.selection = false;
	canvas.hoverCursor = "crosshair";
	canvas.forEachObject(o => {
		o.selectable = false;
		if (o.type === "textbox") {
			o.editable = false;
			if (o.isEditing) o.exitEditing();
		}
	});
}

export function getCanvasA4Size() {
	const mmin = 25.4; // mm/inch
	const wmm = 210,
				hmm = 297; //dimensions of A4 paper are 210mm × 297mm
	const dpi = 150; // the lowest dpi for printing
	const size = {
		w: Math.round((wmm / mmin) * dpi),
		h: Math.round((hmm / mmin) * dpi)
	};
	return size;
}

export function getCanvasSignatureSize() {
	// flipped to horizontal and reduced in size
	const a4Size = getCanvasA4Size();
	const size = {
		w: a4Size.h / 6,
		h: a4Size.w / 6
	};
	return size;
}

export function setPositionX(canvas, diffX) {
	const canvasWidth = canvas.getWidth();
	const viewportWidth = canvas.getElement().parentElement.parentElement.clientWidth;
	const widthOverflow = canvasWidth - viewportWidth;

	for (const iterator of getFabricCanvases(canvas)) {
		let currLeft = Number(iterator.style.left.replace(/[^\d\.\-]/g, ""));
		if (Number.isNaN(currLeft) || (currLeft > -1 && currLeft < 1)) currLeft = 0;
        
		const newLeft = currLeft - diffX;
		const byLeftEgde = Math.min(newLeft, 0);
		const byRightEdge = Math.max(byLeftEgde, -widthOverflow);
		const left = Math.min(byRightEdge, 0);

		iterator.style.left = left + "px";
	}
}

export function setPositionY(canvas, diffY) {
	const canvasHeight = canvas.getHeight();
	const viewportHeight = canvas.getElement().parentElement.parentElement.clientHeight;
	const heightOverflow = canvasHeight - viewportHeight;

	for (const iterator of getFabricCanvases(canvas)) {
		let currTop = Number(iterator.style.top.replace(/[^\d\.\-]/g, ""));
		if (Number.isNaN(currTop) || (currTop > -1 && currTop < 1)) currTop = 0;

		const newTop = currTop - diffY;
		const byTopEgde = Math.min(newTop, 0);
		const byBottomEdge = Math.max(byTopEgde, -heightOverflow);
		const top = Math.min(byBottomEdge, 0);

		iterator.style.top = top + "px";
	}
}

function getFabricCanvases(c) {
	return c.getElement().parentElement.querySelectorAll("canvas");
}
